import React from 'react';
import type { IconPropsSVG } from './types';

export function MotionOn(props: IconPropsSVG): React.JSX.Element {
    return (
        <svg
            viewBox="0 0 63.907 63.907"
            fill="currentColor"
            {...props}
        >
            <circle
                fill="currentColor"
                cx={30.515}
                cy={6.136}
                r={6.136}
            />
            <path
                fill="currentColor"
                d="M47.399 27.455C42.346 24.53 38.2 20.579 34.71 15.931c-2.193-3.084-7.991-2.923-10.347-.097-3.584 3.487-6.625 7.081-9.037 10.677a3.209 3.209 0 0 0 5.329 3.573 54.205 54.205 0 0 1 3.59-4.734c-.051 3.333.116 9.347.2 12.05.028.9-.177 1.78-.595 2.579-3.308 6.317-5.424 12.294-7.572 19.606a3.37 3.37 0 1 0 6.465 1.901c1.982-6.742 3.897-12.201 6.884-17.981.152.006.304.006.458-.001 1.907 5.69 3.815 11.383 5.725 17.073 1.387 4.147 7.822 1.993 6.431-2.155-2.087-6.221-4.171-12.439-6.251-18.659-.121-.357-.414-1.755-.455-2.211-.344-3.832-.469-7.652-.432-11.477a51.027 51.027 0 0 0 9.782 7.328c3.597 2.088 6.063-3.891 2.514-5.948z"
            />
        </svg>
    );
}
